<template>
    <div class="recipe-ingredients-container">
        <p v-if="state.prompt" class="prompt">{{ state.prompt }}</p>

        <table v-if="orderIngredients.length" class="recipe-ingredients">
            <tbody>
                <tr v-for="(ingredient, index) in orderIngredients" :key="`ingredient-row-${ingredient.id}`">
                    <td class="quantity-col" :key="`quantity-${ingredient.id}`">
                        <div class="form-group db" v-bind:class="[getIngredientDatabase(ingredient)]">
                            <span class="form-control quantity"
                                ><input
                                    step="0.1"
                                    class="vue-input-number"
                                    type="number"
                                    :value="ingredient.quantity"
                                    :name="'ingredients[' + index + '][quantity]'"
                                />
                                <span class="unit-visible-xs"
                                    >{{ ingredient.unit }}
                                    {{ ingredient.unitProcessedForm }}
                                    {{ ingredient.ingredient }}</span
                                >
                            </span>
                        </div>
                    </td>

                    <!-- <select id="select-unit" class="unit form-control" v-model="selectedUnitIndex">
                                <option v-for="(index, unit) in units" :value="index">{{ unit.Enhet }} {{ unit.BearbetadForm }}</option>
                            </select> -->

                    <td class="unit-col">
                        <div class="form-group">
                            <span class="form-control unit"
                                >{{ ingredient.unit }} {{ ingredient.unitProcessedForm }}</span
                            >
                            <input
                                type="hidden"
                                v-if="ingredient.unit_id !== undefined"
                                :value="ingredient.unit_id"
                                :name="'ingredients[' + index + '][unit_id]'"
                            />
                            <input
                                type="hidden"
                                v-else
                                :value="ingredient.unit"
                                :name="'ingredients[' + index + '][unit_text]'"
                            />
                        </div>
                    </td>

                    <td class="ingredient-col">
                        <div class="form-group">
                            <span class="form-control"> {{ ingredient.ingredient }}</span>
                            <input
                                type="hidden"
                                v-if="ingredient.ingredient_id"
                                :value="ingredient.ingredient_id"
                                :name="'ingredients[' + index + '][ingredient_id]'"
                            />
                            <input
                                type="hidden"
                                v-else
                                :value="ingredient.ingredient"
                                :name="'ingredients[' + index + '][comment]'"
                            />
                        </div>
                    </td>

                    <td class="remove-ingredient-col actions">
                        <div class="form-group">
                            <svg class="icon remove-ingredient" @click="removeIngredient(index)">
                                <use xlink:href="#icon-minus"></use>
                            </svg>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import state from './../state.js';
import _ from 'lodash';

export default {
    props: {
        initialIngredients: Array
    },

    data() {
        return {
            state
        };
    },

    mounted() {
        if (this.initialIngredients) this.getIngredientList();
    },

    methods: {
        getIngredientList() {
            let recipeIngredients = {};

            this.initialIngredients.forEach((ingredient) => {
                if (ingredient.food_item) {
                    recipeIngredients = {
                        quantity: ingredient.quantity,
                        unit_id: ingredient.unit_id,
                        ingredient: ingredient.food_item.LivsmedelNamn,
                        ingredient_id: ingredient.ingredient_id,
                        unit: ingredient.food_item_unit ? ingredient.food_item_unit.Enhet : 'gram',
                        db: ingredient.food_item.DABAS
                    };
                } else {
                    recipeIngredients = {
                        quantity: ingredient.quantity,
                        unit: ingredient.unit_text,
                        ingredient: ingredient.comment
                    };
                }
                recipeIngredients.id = ingredient.id;

                this.state.recipeIngredients.unshift(recipeIngredients);
                // console.log(this.state.recipeIngredients )
            });
        },

        getIngredientDatabase(ingredient) {
            if (!ingredient.ingredient_id) return;

            if (ingredient.db == 0) {
                return 'db1';
            } else if (ingredient.db > 0) {
                return 'db2';
            }
        },

        removeIngredient(index) {
            this.state.recipeIngredients.splice(index, 1);
        }
    },
    computed: {
        orderIngredients: function () {
            return _.orderBy(this.state.recipeIngredients, 'id', 'asc');
        }
    }
};
</script>
